<template>
  <div class="l-category__wrapper" id="content">
    <div class="l-category__filter" :class="{ open: isFiltersVisible }">
      <div class="l-category__search">
        <input
          v-model="searchTerm"
          :placeholder="translations['What are you looking for?']"
          v-on:keyup.enter="search()"
        />
        <div class="button" @click="search()">
          <svg
            width="28"
            height="27"
            viewBox="0 0 28 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.981 22.6005C9.78254 22.6007 7.63339 21.949 5.80531 20.7278C3.97723 19.5067 2.5523 17.7708 1.71072 15.7398C0.869132 13.7088 0.648681 11.4739 1.07724 9.31763C1.5058 7.16135 2.56411 5.18057 4.11838 3.62575C5.67264 2.07093 7.65303 1.0119 9.80916 0.582565C11.9653 0.153232 14.2003 0.372879 16.2316 1.21373C18.2629 2.05459 19.9992 3.47889 21.2211 5.30653C22.4429 7.13417 23.0954 9.28308 23.096 11.4815C23.0964 12.9415 22.8092 14.3872 22.2508 15.7361C21.6924 17.0851 20.8737 18.3108 19.8416 19.3433C18.8095 20.3758 17.584 21.1949 16.2353 21.7538C14.8865 22.3127 13.4409 22.6004 11.981 22.6005V22.6005ZM11.981 1.98254C10.1021 1.98254 8.26534 2.5397 6.70307 3.58357C5.1408 4.62745 3.92316 6.11115 3.20413 7.84704C2.4851 9.58294 2.29697 11.4931 2.66353 13.3359C3.03009 15.1787 3.93487 16.8715 5.26347 18.2001C6.59207 19.5286 8.28481 20.4334 10.1276 20.8C11.9704 21.1666 13.8806 20.9784 15.6165 20.2594C17.3524 19.5404 18.8361 18.3227 19.8799 16.7605C20.9238 15.1982 21.481 13.3615 21.481 11.4825C21.481 8.96298 20.4801 6.54662 18.6985 4.76502C16.9169 2.98342 14.5005 1.98254 11.981 1.98254V1.98254Z"
              fill="#919191"
            />
            <path
              d="M26.496 26.8075C26.3901 26.8079 26.2852 26.7872 26.1873 26.7467C26.0895 26.7062 26.0007 26.6466 25.926 26.5715L18.771 19.4165C18.6934 19.3422 18.6314 19.2532 18.5886 19.1546C18.5459 19.056 18.5233 18.9498 18.5221 18.8424C18.5209 18.7349 18.5413 18.6284 18.5818 18.5289C18.6224 18.4294 18.6825 18.339 18.7584 18.263C18.8344 18.187 18.9248 18.127 19.0243 18.0864C19.1238 18.0458 19.2304 18.0255 19.3378 18.0267C19.4453 18.0278 19.5514 18.0505 19.65 18.0932C19.7486 18.1359 19.8377 18.1979 19.912 18.2755L27.067 25.4305C27.1796 25.5434 27.2562 25.6871 27.2873 25.8434C27.3183 25.9998 27.3023 26.1619 27.2414 26.3092C27.1804 26.4565 27.0772 26.5824 26.9447 26.6711C26.8122 26.7598 26.6564 26.8073 26.497 26.8075H26.496Z"
              fill="#919191"
            />
          </svg>
        </div>
        <div class="toggle" @click="showFilters()" v-if="!isFiltersVisible">
          {{ translations["More filtering options"] }}
          <svg
            width="10"
            height="7"
            viewBox="0 0 10 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.086 0.827995L0.171997 1.74199L4.743 6.314L9.314 1.74299L8.4 0.828995L4.743 4.48499L1.086 0.827995Z"
              fill="white"
            />
          </svg>
        </div>
        <div class="toggle" @click="hideFilters()" v-if="isFiltersVisible">
          {{ translations["Less filtering options"] }}
          <svg
            width="10"
            height="7"
            viewBox="0 0 10 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.086 0.827995L0.171997 1.74199L4.743 6.314L9.314 1.74299L8.4 0.828995L4.743 4.48499L1.086 0.827995Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
      <transition name="fade">
        <div class="l-category__filters" v-if="isFiltersVisible">
          <div class="l-category__filter-dropdowns">
            <multiselect
              v-for="option in filterOptions"
              :key="option.id"
              v-model="filters[option.handle]"
              :options="option.options"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              :placeholder="option.label"
              label="label"
              track-by="label"
              :preselect-first="false"
              :taggable="false"
              mode="multiple"
              @close="toggleFilter('close')"
              @open="toggleFilter('open')"
            >
              <template
                slot="selection"
                slot-scope="{ values, search, isOpen }"
              >
                <span
                  class="multiselect__single"
                  v-show="values.length && !isOpen"
                >
                  {{ option.label }} ({{ values.length }})
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <div class="option__wrapper">
                  <span class="option__box"></span>
                  <span class="option__label"> {{ props.option.label }} </span>
                </div>
              </template>
            </multiselect>
          </div>
          <div class="l-category__filtersaction">
            <div @click="reset()" class="reset">
              {{ translations["Reset filtering"] }}
            </div>
            <!-- <div @click="filter()" class="o-btn o-btn--filled">
              {{ translations["Filter products"] }}
            </div> -->
          </div>
        </div>
      </transition>
      <div class="l-category__filtersaction--mobile">
        <div class="toggle" @click="showFilters()" v-if="!isFiltersVisible">
          {{ translations["More filtering options"] }}
          <svg
            width="10"
            height="7"
            viewBox="0 0 10 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.086 0.827995L0.171997 1.74199L4.743 6.314L9.314 1.74299L8.4 0.828995L4.743 4.48499L1.086 0.827995Z"
              fill="white"
            />
          </svg>
        </div>
        <div class="toggle" @click="hideFilters()" v-if="isFiltersVisible">
          {{ translations["Less filtering options"] }}
          <svg
            width="10"
            height="7"
            viewBox="0 0 10 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.086 0.827995L0.171997 1.74199L4.743 6.314L9.314 1.74299L8.4 0.828995L4.743 4.48499L1.086 0.827995Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
    </div>

    <div class="l-category__grid-tools">
      <div>
        {{ translations["Showing"] }} <span>{{ totalLoaded }}</span>
        {{ translations["products"] }}
      </div>
      <div class="sorting" :class="'sorting--' + sortDirection">
        <div class="direction" @click="toggleDirection()">
          <img src="/images/sort.svg" />
        </div>
        <div class="type">
          <multiselect
            v-model="selectedSortOption"
            deselect-label="Can't remove this value"
            track-by="code"
            label="label"
            placeholder="Sort by..."
            :options="sortOptions"
            :searchable="false"
            :clear-on-select="false"
            :taggable="false"
            :show-labels="false"
          >
            <template slot="singleLabel" slot-scope="props">
              <span class="option__desc">
                <span class="option__title">{{ props.option.label }}</span>
              </span>
            </template>
          </multiselect>
        </div>
      </div>
    </div>

    <div class="l-category__grid" id="grid">
      <slot name="products"></slot>
    </div>

    <div
      class="l-category__row l-category__loadmore c-categoryGrid__loadMore"
      v-if="showLoadMore"
    >
      <div class="o-btn" @click="loadNextPage()" :class="{ loading: loading }">
        <inline-loader></inline-loader>
      </div>
    </div>

    <div class="l-category__row">
      <div class="l-category__counter">
        {{ translations["Showing"] }} <span>{{ totalLoaded }}</span>
        {{ translations["of"] }} {{ totalProducts }}
        {{ translations["products"] }}
      </div>
    </div>

    <transition name="fade">
      <div class="c-categoryGrid__loader" v-if="showLoader">
        <slot name="loader"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { debounce } from "../scripts/helpers";

import multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import InlineLoader from "./InlineLoader.vue";
import Dropdown from "./Dropdown.vue";

export default {
  name: "CategoryGrid",
  components: {
    InlineLoader,
    vSelect,
    Dropdown,
    multiselect,
  },
  props: {
    page: {
      type: Number,
      default: 1,
    },
    loaded: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 0,
    },
    results: {
      type: Number,
      default: 0,
    },
    batch: {
      type: Number,
      default: 0,
    },
    buttonLabel: {
      type: String,
      default: "",
    },
    loadedOption: {
      type: String,
      default: "title",
    },
    loadedDirection: {
      type: String,
      default: "asc",
    },
    showPrice: {
      type: Number,
      default: 0,
    },
    filterOptions: {
      type: Array,
    },
    translations: {
      type: Object,
    },
  },
  data: () => ({
    initial: true,
    showLoader: false,
    isFiltersVisible: false,
    loading: false,
    currentPage: 0,
    totalPages: 0,
    totalProducts: 0,
    totalLoaded: 0,
    url: "",
    queryParams: new URLSearchParams(window.location.search),
    sortDirection: "",
    sortOption: "",
    filters: {},
    searchTerm: "",
    selectedSortOption: null,

    filterChanged: false,
    filterOpen: false,
  }),
  watch: {
    selectedSortOption: function (newProperty, oldProperty) {
      if (this.initial || !oldProperty) {
        return true;
      }
      this.updateParam("sortBy", newProperty.code);
      this.removeParam("page");
      this.reloadProducts();
    },
    filters: function (newProperty, oldProperty) {
      if (this.initial || !oldProperty) {
        return true;
      }
      this.filterChanged = true;
    },
  },
  computed: {
    showLoadMore: function () {
      if (this.currentPage >= this.totalPages) {
        return false;
      }
      return true;
    },
    sortOptions: function () {
      if (this.showPrice) {
        return [
          { label: "Title", code: "title" },
          { label: "WLL", code: "wll" },
          { label: "Volume", code: "volume" },
          { label: "Price", code: "defaultPrice" },
        ];
      } else {
        return [
          { label: "Title", code: "title" },
          { label: "WLL", code: "wll" },
          { label: "Volume", code: "volume" },
        ];
      }
    },
  },
  methods: {
    //Filters visibility
    showFilters: function () {
      this.isFiltersVisible = true;
    },
    hideFilters: function () {
      this.isFiltersVisible = false;
    },

    //Helper methods for dropdowns
    openFilter: debounce((vm) => {
      vm.filterOpen = true;
    }, 200),

    closeFilter: function () {
      this.filterOpen = false;

      if (this.filterChanged) {
        this.filter(this);
      }
    },
    toggleFilter: function (action) {
      if (action == "close") {
        this.closeFilter();
      }

      if (action == "open") {
        this.openFilter(this);
      }
    },

    //Get data
    reset: function () {
      this.filters = {};
      this.filter(this);
    },

    loadMore: function () {
      this.handleScroll(this);
    },

    toggleDirection: function () {
      this.sortDirection = this.sortDirection == "asc" ? "desc" : "asc";

      this.updateParam("direction", this.sortDirection);
      this.removeParam("page");
      this.reloadProducts();
    },
    updateParam: function (param, value) {
      this.queryParams.set(param, value);
    },
    removeParam: function (param) {
      this.queryParams.delete(param);
    },
    search: function () {
      if (this.searchTerm) {
        this.updateParam("searchTerm", this.searchTerm);
      } else {
        this.removeParam("searchTerm");
      }
      this.reloadProducts();
    },
    filter: debounce((vm) => {
      if (!vm.filterOpen) {
        //Reset params
        vm.queryParams.forEach((v, k) => {
          vm.removeParam(k);
        });

        for (const [key, value] of Object.entries(vm.filters)) {
          if (value.length) {
            let tmpVal = [];
            for (const [key2, option] of Object.entries(value)) {
              tmpVal.push(option.code);
            }
            vm.updateParam(key, tmpVal);
          }

          if (!value.length) {
            vm.removeParam(key);
          }
        }

        vm.removeParam("page");
        vm.search();
      }
    }, 300),

    reloadProducts: function () {
      this.showLoader = true;
      this.load()
        .then((response) => {
          this.totalPages = response.headers.totalpages;
          this.totalProducts = response.headers.totalproducts;
          this.totalLoaded = response.headers.totalloaded;

          document.getElementById("grid").innerHTML = response.data;
        })
        .then(() => {
          this.currentPage = 1;
          this.showLoader = false;
        });
    },
    loadNextPage: function () {
      let pageNum = this.queryParams.get("page")
        ? parseInt(this.queryParams.get("page")) + 1
        : 2;

      this.updateParam("page", pageNum);

      // Load next page of products
      this.loading = true;
      this.load()
        .then((response) => {
          this.totalPages = response.headers.totalpages;
          this.totalProducts = response.headers.totalproducts;
          this.totalLoaded = response.headers.totalloaded;

          document
            .getElementById("grid")
            .insertAdjacentHTML("beforeend", response.data);
        })
        .then(() => {
          this.currentPage = pageNum;
          this.loading = false;
        });
    },
    load: function () {
      history.pushState(null, null, "?" + this.queryParams.toString());
      axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

      return axios.get(this.url + "?" + this.queryParams.toString());
    },

    handleScroll: debounce((vm) => {
      if (window.scrollY + window.innerHeight >= (document.body.offsetHeight - 500)) {
        if(vm.showLoadMore){
          vm.loadNextPage()
        }
      }
    }, 650),
  },
  
  created() {
    window.addEventListener('scroll', this.loadMore, { passive: true });
    this.currentPage = this.page;
    this.totalPages = this.total;
    this.totalProducts = this.results;
    this.totalLoaded = this.loaded;
    this.url = location.protocol + "//" + location.host + location.pathname;

    this.sortDirection = this.loadedDirection;
    this.searchTerm = this.queryParams.get("searchTerm");
    this.selectedSortOption = this.sortOptions.find((option) => {
      return option.code == this.loadedOption;
    });

    this.filterOptions.forEach((optionset) => {
      let params = this.queryParams.getAll(optionset.handle);

      if (params.length) {
        params = params[0].split(",");
        this.filters[optionset.handle] = optionset.options.filter((option) => {
          return params.find((param) => {
            return param == option.code;
          });
        });
      }
    });
  },
  mounted() {
    this.initial = false;
  },
  destroyed() {
			window.removeEventListener('scroll', this.handleScroll(this));
  },
};
</script>

<style lang="scss">
@import "../../scss/base/variables.scss";

.c-categoryGrid {
  position: relative;

  &__grid {
    display: flex;
    flex-wrap: wrap;
  }

  &__loadMore {
    border: none;
    opacity: 1;

    .o-btn {
      position: relative;
      border: none;
      opacity: 1;

      .o-loaderInline {
        display: none;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        margin-left: -22px;

        opacity: 1;
      }

      &.loading {
        .o-loaderInline {
          display: inline-block;
        }
      }
    }
  }
  
}
</style>
